<template>
  <div>
    <FITModal ref="deleteFormModal" reference="modal" :title="$t('general.CURD.delete')" @click="onClickModalDelete">
      <div slot="body">
 		<h5 class="mb-3">{{$t('dw.form.list.deleteModalMsg')}}</h5>
        <p class="my-2"><b>{{form.formEnglishName}}</b></p>
        <p class="my-2"><b>{{form.formChineseName}}</b></p>
      </div>
    </FITModal>
    <b-row align-h="center" class="mt-0 pt-0">
      <div class="w-75">
        <FITFormCard>
          <div slot="header">
            <b-row align-v="center">
              <b-col cols="6">
                <h4>{{$t('dw.form.create.header')}}</h4></b-col>
              <b-col cols="auto" class="ml-auto" v-if="detail">
                <FITButton v-if="this.detail && permissionLevel<3.5" size="md" :text="$t('general.CURD.delete')" variant="danger" @click="onClickDelete"></FITButton>
              </b-col>
            </b-row>
          </div>
          <div slot="formBody">
            <div>
           	<FITAutoSearch field='providerID' :rule="{required:true}"  :label="$t('osm.provider.header')" :width="8" v-model="selectedProvider" dest=option v-bind="providerAutoSearchParams"></FITAutoSearch>
              <FITSelect field="formCategory" :rule="{required:true}" :label="$t('dw.form.create.formCategory')" :width="8" v-model="form.formCategory" :options="formCategoryOptions"></FITSelect>
              <FITTextInput field="formEnglishName" :rule="{required:true}" :label="$t('dw.form.create.formEnglishName')" :width="8" v-model="form.formEnglishName"></FITTextInput>
              <FITTextInput field="formChineseName" :rule="{required:true}" :label="$t('dw.form.create.formChineseName')" :width="8" v-model="form.formChineseName"></FITTextInput>
              <FITTextInput field="formLink" :rule="{required:true}" :label="$t('dw.form.create.formLink')" :width="8" v-model="form.formLink"></FITTextInput>
              <FITTextarea field="remarks" :rule="{required:true}" :label="$t('dw.form.create.remarks')" :width="8" v-model="form.remarks"></FITTextarea>
            </div>
            <b-row>
              <b-col class="text-right">
                <FITButton v-if="!this.detail && permissionLevel<3.5" size="md" :text="$t('general.submit')" variant="primary" @click="validationCheck"></FITButton>
                <FITButton v-if="this.detail && permissionLevel<3.5" size="md" :text="$t('general.edit')" variant="warning" @click="validationCheck"></FITButton>
              </b-col>
            </b-row>
          </div>
        </FITFormCard>
      </div>
    </b-row>
  </div>
</template>
<script type="text/javascript">
import Vue from 'vue'
import { FITFormCard, FITTextInput, FITTextarea, FITButton, FITModal, FITSelect, FITAutoSearch,FITValidationBus} from '@/components'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'ProviderCreate',
  components: {
    FITFormCard,
    FITTextInput,
    FITTextarea,
    FITButton,
    FITModal, 
    FITSelect, 
    FITAutoSearch
  },
  created() {
    FITValidationBus.$emit('reset',true);
    this.$store.commit('Validation/validationReset');
    this.$store.commit('Validation/setAlertMsg', { alertMsg: this.$t("validation.alertMsg.error") });

     if (this.detail) {
      console.log(this.detail);
      this.$store.dispatch('Dw/getFormDetail', this.detail.ID).then((data) => {
        //  Update Form
        this.formDataUpdate(data);
        this.form.ID = data.ID;
        // Update Provider 
        Vue.set(this, 'selectedProvider', {
          ID: data.providerID,
          providerCode: data.providerCode,
          providerEnglishName: data.providerEnglishName,
          providerChineseName: data.providerChineseName
        })
      }).catch((err) => {
        console.error(err);
      })
    }
    this.$store.dispatch('getAllSelections', 'form')
      .then((json) => {
        this.$store.commit({ type: 'Dw/setSelections', selections: json.data });
      })
      .catch((err) => {
        console.error(err);
      })
  },
  methods: {
    formDataUpdate(data){
      let form = this.form;
      form.providerID = data.providerID;
      form.formCategory = data.formCategory;
      form.formChineseName = data.formChineseName;
      form.formEnglishName = data.formEnglishName;
      form.formLink = data.formLink;
      form.remarks = data.remarks;
    },
    submit() {
      let action = 'Dw/createForm'
      if (this.detail) {
        action = 'Dw/editForm';
      }

      var data = JSON.parse(JSON.stringify(this.form));

      this.$store.dispatch(action, data).then((json) => {
        this.$router.replace({ name: 'Form List', params: { alertContent: this.$t('general.updateSuccess'), alertVariant: 'success' } });
      }).catch((error) => {
        console.debug(error);
      })
    },
    convertFloatToPercent(input) {
      var ans = (parseFloat(input) * 100).toFixed(2);
      return isNaN(ans) ? "" : ans;
    },
    convertPercentToFloat(input) {
      var ans = (input / 100).toFixed(2);
      return isNaN(ans) ? "" : ans;
    },
    validationCheck() {
      this.$store.dispatch('Validation/validationCheckBeforeSubmit');
      return;
    },

    onClickModalDelete(event) {
      if (!event) {
        return;
      }
      this.$store.dispatch('Dw/deleteForm', this.form.ID).then((json) => {
        this.$refs.deleteFormModal.closeModal();
        this.$router.replace({
          name: 'Form List',
          params: { alertContent: this.$t('general.deleteSuccess'), alertVariant: 'success' }
        })
      })
    },
    onClickDelete() {
      this.$refs.deleteFormModal.openModal();
    }
  },
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState({
      'vuexFinalResult': state => state.Validation.validationFinalResult,
    }),
    ...mapGetters(['getTranslated']),
    formCategoryOptions() {
      return this.getTranslated(this.$i18n.locale, 'Dw', 'formCategory');
    },
    permissionLevel(){
      return this.$store.state.permissionLevel;
    },

  },
  watch: {
    selectedProvider(newData, oldData) {
      Vue.set(this.form, 'providerID', newData.ID);
    },
    vuexFinalResult(newData, oldData) {
      let result = newData;
      // console.log("Final Result: "+newData);
      if (result) {
        this.submit();
        this.$store.commit('Validation/validationReset');
        FITValidationBus.$emit('reset', true);
      }
    }
  },
  data() {
    return {
      form: {
        providerID: '',
        formChineseName: '',
        formEnglishName: '',
        formCategory: '',
        formLink: '',
        remarks: '',
      },
      providerAutoSearchParams: {
        placeholder: 'Type to search',
        dest: 'provider',
        paras: [{ key: 'type', value: "provider" }],
        showItems: ['providerCode', 'providerEnglishName', 'providerChineseName']
      },
      selectedProvider:{ID:-1}
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/Dw/FormManagement/FormCreate.vue